import { c as compute_rest_props, b as compute_slots } from "./utils.js";
import { c as create_ssr_component, g as getContext, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, e as escape, f as createEventDispatcher, v as validate_component } from "./ssr.js";
import { L as Label } from "./Label.js";
import { I as Input } from "./Input.js";
import { twMerge } from "tailwind-merge";
import { I as IconSolid } from "./IconSolid.js";
import { P as PenSolid } from "./PenSolid.js";
const CloseOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "close outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M6 18 17.94 6M18 18 6.06 6"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M6 18 17.94 6M18 18 6.06 6"></path></svg>`} `;
});
const Typeahead = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  compute_slots(slots);
  let { id = "input-" + Math.random().toString(36) } = $$props;
  let { displayProperty = "name" } = $$props;
  let { label = "" } = $$props;
  let { value = "" } = $$props;
  let { data } = $$props;
  let { inputClass = "" } = $$props;
  let { placeholder = "" } = $$props;
  let { required = true } = $$props;
  let { icon = PenSolid } = $$props;
  let { extract = (item) => item } = $$props;
  createEventDispatcher();
  let searchRef = null;
  if ($$props.id === void 0 && $$bindings.id && id !== void 0) $$bindings.id(id);
  if ($$props.displayProperty === void 0 && $$bindings.displayProperty && displayProperty !== void 0) $$bindings.displayProperty(displayProperty);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0) $$bindings.label(label);
  if ($$props.value === void 0 && $$bindings.value && value !== void 0) $$bindings.value(value);
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  if ($$props.inputClass === void 0 && $$bindings.inputClass && inputClass !== void 0) $$bindings.inputClass(inputClass);
  if ($$props.placeholder === void 0 && $$bindings.placeholder && placeholder !== void 0) $$bindings.placeholder(placeholder);
  if ($$props.required === void 0 && $$bindings.required && required !== void 0) $$bindings.required(required);
  if ($$props.icon === void 0 && $$bindings.icon && icon !== void 0) $$bindings.icon(icon);
  if ($$props.extract === void 0 && $$bindings.extract && extract !== void 0) $$bindings.extract(extract);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    !value || value.length === 0 ? [] : data.filter((x) => typeof x[displayProperty] === "string" ? x[displayProperty].toLowerCase().includes(value.toLowerCase()) : x[displayProperty].toString().toLowerCase().includes(value));
    $$rendered = `<div class="relative w-full">${validate_component(Label, "Label").$$render($$result, { for: id, class: "space-y-2 relative" }, {}, {
      default: () => {
        return `${label ? `<span>${escape(label)}</span>` : ``} ${validate_component(Input, "Input").$$render(
          $$result,
          {
            required,
            class: inputClass,
            id,
            placeholder,
            type: "text",
            this: searchRef,
            value
          },
          {
            this: ($$value) => {
              searchRef = $$value;
              $$settled = false;
            },
            value: ($$value) => {
              value = $$value;
              $$settled = false;
            }
          },
          {
            right: () => {
              return `<div slot="right" class="flex gap-2">${``} ${value && value.length > 2 ? `<div role="button" tabindex="-1">${validate_component(CloseOutline, "CloseOutline").$$render($$result, { class: "w-3 cursor-pointer text-red-400" }, {}, {})}</div>` : ``}</div>`;
            },
            left: () => {
              return `<span slot="left">${typeof icon === "string" ? `<i class="${"la text-primary-400 text-[24px] " + escape(icon, true)}"></i>` : `${validate_component(IconSolid, "IconSolid").$$render($$result, { icon, class: "text-primary-400" }, {}, {})}`}</span>`;
            }
          }
        )}`;
      }
    })} ${``}</div>`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Typeahead as T
};
//# sourceMappingURL=Typeahead.js.map
